import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "UpDownArrows",
  "use": "UpDownArrows-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"UpDownArrows\">\n<path d=\"M19.6364 13.5591V4H16.7273V13.5591H12.3636L18.1818 19L24 13.5591H19.6364ZM5.81818 4L0 9.44091H4.36364V19H7.27273V9.44091H11.6364L5.81818 4Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol